import styled from 'styled-components';
import colors from '../../constants/color';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;
export const ContainerModal = styled.div`
  display: flex;
  flex-direction: column;
  height: 400px;
  width: 500px;
  border-radius: 20px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  width: 100%;
  border-bottom: 0.5px solid #C4C4C4;
`;
export const TitleHeader = styled.small`
  font-size: 14px;
  color: ${colors.black};
  margin-left: 10px;
`;
export const SizedBox: any = styled.div`
  margin-top: 32px;
`;
